(function () {
    'use strict';

    function platformEntityReferralDataService($http) {
        var baseUrl = '[BuildifyApiHost]/api/platformentityreferrals';

        function createPlatformEntityReferral(data) {
            return $http.post(baseUrl, data).then(function (response) {
                return response.data;
            });
        };

        function updatePlatformEntityReferral(id, data) {
            return $http.put(baseUrl + '/' + id, data).then(function (response) {
                return response.data;
            });
        };

        function removePlatformEntityReferral(id, objectId, path) {
            return $http.post(baseUrl + '/' + id + '/delete', {
                ObjectId: objectId,
                ObjectPath: path
            }).then(function (response) {
                return response.data;
            });
        };

        return {
            createPlatformEntityReferral: createPlatformEntityReferral,
            updatePlatformEntityReferral: updatePlatformEntityReferral,
            removePlatformEntityReferral: removePlatformEntityReferral
        }
    }

    platformEntityReferralDataService.$inject = ['$http'];

    angular.module('ecap.common').service('platformEntityReferralDataService', platformEntityReferralDataService);
})();
